// src/utils/services/CodingOpportunities/getCodingOpportunities.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CodingOpportunities`;

/**
 * Obtiene el listado paginado de Coding Opportunities.
 *
 * filters = {
 *   pcpId, status, measureYear, memberType,
 *   cipId, locationId, page, pageSize
 * }
 */
const getCodingOpportunities = async (filters = {}) => {
  try {
    const response = await axios.get(API_URL, {
      params: {
        pcpId: filters.pcpId || "",
        status: filters.status || "",
        measureYear: filters.measureYear || "",
        memberType: filters.memberType || "",
        cipId: filters.cipId || "",
        locationId: filters.locationId || "",
        page: filters.page || 1,
        pageSize: filters.pageSize || 50,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // backend devuelve { data, page, pageSize, total, totalPages }
    return response.data;
  } catch (error) {
    console.error("Error fetching coding opportunities:", error);
    throw error;
  }
};

export default getCodingOpportunities;
